import { render, staticRenderFns } from "./RequestReturnFilter.vue?vue&type=template&id=2678febd&"
import script from "./RequestReturnFilter.vue?vue&type=script&lang=js&"
export * from "./RequestReturnFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports